import { ACCENT, TEAL, BG_WARM, BG_SECTION } from '../utils/theme';

interface TrustSectionProps {
  onOpenModal?: () => void; // CTA削除のためオプション化
}

const CONDITIONS = [
  { icon: 'ri-money-cny-circle-line', label: '月収アップ',  color: '#F56B96' },
  { icon: 'ri-moon-line',             label: '夜勤を減らす', color: '#C4A8D4' },
  { icon: 'ri-calendar-check-line',   label: '休日を増やす', color: '#5CBFB0' },
  { icon: 'ri-train-line',            label: '通勤をラクに', color: '#7BBFCA' },
];

const ASSURANCES = [
  { icon: 'ri-user-heart-line', label: '元看護師の\n専任担当', sub: '看護師経験者が対応' },
  { icon: 'ri-lock-line',       label: '完全秘密',            sub: '情報は厳重に管理' },
  { icon: 'ri-time-line',       label: '自分のペース',        sub: '急かすことはしません' },
];

export default function TrustSection({ onOpenModal: _onOpenModal }: TrustSectionProps) {
  return (
    <section style={{ background: '#fff' }}>
      {/* ─── こんな条件改善が可能です ─── */}
      <div
        style={{ maxWidth: 430, margin: '0 auto', padding: '32px 20px 0' }}
        data-track-view="true"
        data-element-id="conditions_section"
        data-element-type="section"
        data-element-name="条件改善メニュー"
        data-element-index="0"
      >
        <h2 style={{ fontSize: 17, fontWeight: 800, color: '#2a2a2a', marginBottom: 6 }}>
          こんな条件改善が可能です
        </h2>
        <p style={{ fontSize: 12, color: '#aaa', marginBottom: 16 }}>
          働き方はそのままに、条件だけを見直すことができます
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          {CONDITIONS.map((c) => (
            <div
              key={c.label}
              style={{
                background: `${c.color}10`,
                border: `1.5px solid ${c.color}35`,
                borderRadius: 14,
                padding: '18px 14px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 10,
              }}
            >
              <div
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: '50%',
                  background: `${c.color}25`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <i className={c.icon} style={{ fontSize: 20, color: c.color }} />
              </div>
              <span style={{ fontSize: 13, fontWeight: 700, color: '#2a2a2a', whiteSpace: 'nowrap' }}>
                {c.label}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* ─── 3つの安心バッジ ─── */}
      <div
        style={{
          maxWidth: 430,
          margin: '28px auto 0',
          padding: '28px 20px 36px',
          background: `linear-gradient(135deg, ${BG_SECTION} 0%, ${BG_WARM} 100%)`,
          borderTop: '1px solid #FFE4EC',
          borderBottom: '1px solid #FFE4EC',
        }}
        data-track-view="true"
        data-element-id="assurance_section"
        data-element-type="section"
        data-element-name="安心セクション"
        data-element-index="0"
      >
        <div style={{ display: 'flex', justifyContent: 'space-around', gap: 8 }}>
          {ASSURANCES.map((a) => (
            <div
              key={a.label}
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, flex: 1 }}
            >
              <div
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: '50%',
                  background: `${ACCENT}20`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <i className={a.icon} style={{ fontSize: 22, color: ACCENT }} />
              </div>
              <span
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: '#2a2a2a',
                  textAlign: 'center',
                  lineHeight: 1.5,
                  whiteSpace: 'pre-line',
                }}
              >
                {a.label}
              </span>
              <span style={{ fontSize: 10, color: '#aaa', textAlign: 'center', lineHeight: 1.5 }}>
                {a.sub}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
